import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../constants/common'
import { useNotification } from '../../../hooks'
import { AttachServiceRequestsModal } from '../../Request'
import {
  ProfileEntityWidgetItemContent,
  ServiceRequestsWidgetItem,
  Widget,
  WidgetContentItemsList,
} from '../../Widget'
import { updateNewsboard } from '../Newsboard.api'
import { useNewsboardPostProfileContext } from '../Newsboard.hooks'

import {
  getAttachRequestsPayload,
  getServiceRequestListItemProps,
} from './NewsboardPostProfileWidgetServiceRequests.utils'
import { NewsboardPostProfileWidgetServiceRequestsEditButton } from './NewsboardPostProfileWidgetServiceRequestsEditButton'

function NewsboardPostProfileWidgetServiceRequests() {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const {
    handleCloseModal,
    handleEntityReload,
    isInitiated,
    postData,
    setModal,
  } = useNewsboardPostProfileContext()

  const requests = postData?.request_objs || EMPTY_LIST

  const canEdit = postData?.permissions?.can_edit

  function handleAttachRequests(value) {
    updateNewsboard(postData.uuid, getAttachRequestsPayload(value))
      .then(() => {
        handleCloseModal()
        handleAddSuccessNotification(
          'Notification.NewsboardPostRequestConnectedKey'
        )
        handleEntityReload?.()
      })
      .catch(() => {
        handleCloseModal()
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  function handleOpenAttachModal() {
    setModal(
      <AttachServiceRequestsModal
        allowEmptySelection
        multipleSelection
        headerProps={{ text: 'Modal.AttachRequestsToPostTitleKey' }}
        initialSelection={requests}
        restoreAttention={false}
        onClose={handleCloseModal}
        onSelectedAttachRequests={handleAttachRequests}
      />
    )
  }

  return (
    <Widget
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: canEdit
              ? NewsboardPostProfileWidgetServiceRequestsEditButton
              : null,
            editButtonProps: { onClick: handleOpenAttachModal },
          },
        },
      }}
      isSkeleton={!isInitiated}
      title={t('NewsboardPostProfile.ServiceRequestsWidgetTitleKey')}
    >
      <WidgetContentItemsList
        Item={ServiceRequestsWidgetItem}
        emptyStateText={t('NewsboardPostProfile.NoServiceRequestsKey')}
        getItemPropsFromValue={getServiceRequestListItemProps}
        itemProps={{
          ContentContainer: ProfileEntityWidgetItemContent,
        }}
        items={requests}
        title={t(
          'NewsboardPostProfile.AttachedServiceRequestsWidgetListTitleKey',
          { count: requests.length }
        )}
      />
    </Widget>
  )
}

export default NewsboardPostProfileWidgetServiceRequests
